import { Component } from '@theme/component';

/**
 * Triggers the native OS share sheet via the Web Share API when available.
 * Falls back to copying the share URL to the clipboard and revealing a
 * "Link copied" message otherwise.
 * @extends {Component}
 */
class ShareButtonComponent extends Component {
  async share() {
    const url = this.getAttribute('share-url');
    const title = this.getAttribute('share-title') || document.title;

    if (!url) return;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch (error) {
        // Ignore cancellation (AbortError) and other share-sheet errors.
      }
      return;
    }

    await this.copyToClipboard(url);
  }

  /**
   * @param {string} url
   */
  async copyToClipboard(url) {
    if (!navigator.clipboard) return;

    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      return;
    }

    const successMessage = this.refs.copySuccessMessage;

    if (!(successMessage instanceof Element)) return;

    successMessage.classList.remove('visually-hidden');

    window.clearTimeout(this.hideMessageTimeout);
    this.hideMessageTimeout = window.setTimeout(() => {
      successMessage.classList.add('visually-hidden');
    }, 2500);
  }
}

if (!customElements.get('share-button-component')) {
  customElements.define('share-button-component', ShareButtonComponent);
}
